import React, { useState } from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import {
  getStringSearchOr,
  getStringSearchPlaceholder,
} from '../../../../helpers/search';

const stringSearchFields = [
  {
    field: 'name',
    label: 'Name',
  },
  {
    field: 'description',
    label: 'Description',
  },
];

type FilterBarPlansProps = FilterBarProps<Record<string, any>>;

const FilterBarPlans: React.FC<FilterBarPlansProps> = (props) => {
  const { filters = {}, setFilters, selectedId } = props;
  const [stringSearch, setStringSearch] = useState<string>('');

  return (
    <Flex variant="filterBar.container" {...(props as any)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={350}
          value={stringSearch}
          onChange={(event) => {
            const value = event.target.value;
            setStringSearch(value);
            setFilters({
              ...filters,
              or: getStringSearchOr(stringSearchFields, value),
            });
          }}
        />
      </Flex>
    </Flex>
  );
};

FilterBarPlans.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarPlans;
